<template>
  <Modal :activeModal="activeModal" @closeModal="closeModal">
    <template v-slot:btnActivator>
      <v-btn tile :color="variables.colorPrimary" dark class="mb-2 modal-cadastro-btn-cadastrar" @click="openModal"
        :loading="loadingBtnCadastro">Novo cadastro</v-btn>
    </template>
    <v-card>
      <v-toolbar flat height="40px" class="modal-cadastro-toolbar">
        {{ isEdit ? `Editar Contrato: ${item.id} ` : 'Cadastrar Contrato' }}
        <v-spacer></v-spacer>
        <v-icon @click="closeModal" class="modal-cadastro-close">close</v-icon>
      </v-toolbar>

      <v-col class="d-flex justify-center align-center" style="min-height: 300px; width: 100%;" v-if="loadingModal">
        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      </v-col>

      <v-form v-else>
        <v-card-text class="modal-cadastro-form">
          <v-row>
            <!-- Tipos de contratos -->
            <v-col cols="6" class="modal-cadastro-form-col-imput mt-2">
              <v-text-field class="contrato" :error-messages="nomeErrors" v-model="item.name" type="text"
                label="Nome do Contrato:" placeholder="Nome" @input="$v.item.name.$touch()"
                @blur="$v.item.name.$touch()" />
            </v-col>

            <!-- Tipos de contratos -->
            <v-col cols="6" class="modal-cadastro-form-col-imput mt-2">
              <v-autocomplete tabindex="1" class="contrato" v-model="item.contractTypeId"
                :items="listTipeSelectContrato" label="Tipo de Contrato" item-text="text" item-value="value"
                @input="$v.item.contractTypeId.$touch()" @blur="$v.item.contractTypeId.$touch()"
                :disabled="item.id ? true : false" :error-messages="contractTypeIdErrors"
                v-on:keyup="searchAutoCompleteTiposContratos" :search-input.sync="searchTextTipoContratos"
                :loading="isLoadingAutoCompleteTipoContratos" />
            </v-col>

            <!-- Tipos de Operacoes  -->
            <v-col cols="12" v-if="item.contractTypeId === 'CPA'" class="pt-0 pb-0 modal-cadastro-form-col-imput">
              <v-row>
                <v-col cols="12" class="title pb-0 modal-cadastro-form-col-imput mt-4">
                  <v-card class=" pt-0">
                    <v-card-text class="title py-0 px-0"> Condições </v-card-text>
                    <hr class="w-100">
                    <v-card-text class="py-0 mt-4">
                      <v-row class="mt-0">
                        <v-col class="modal-cadastro-form-col-imput px-0">
                          <v-autocomplete tabindex="1" v-model="itemOperator.fieldId" :items="listaConditions"
                            label="Tipo:" item-text="text" item-value="id" :return-object="true" :loading="false"
                            @input="$v.itemOperator.fieldId.$touch()" @blur="$v.itemOperator.fieldId.$touch()"
                            :error-messages="typeOperatorErrors" />
                        </v-col>

                        <v-col class="modal-cadastro-form-col-imput px-2 my-0">
                          <v-autocomplete tabindex="1" v-model="itemOperator.operator" :items="listTypeSelectOperators"
                            label="Condições:" @input="$v.itemOperator.operator.$touch()"
                            @blur="$v.itemOperator.operator.$touch()" :error-messages="conditionOperatorErrors"
                            :loading="false" />
                        </v-col>

                        <v-col class="modal-cadastro-form-col-imput px-2 my-0 mt-4 pe-0">
                          <v-currency-field v-model="itemOperator.value" label="Montante:" prefix="R$"
                            @input="$v.itemOperator.value.$touch()" @blur="$v.itemOperator.value.$touch()"
                            :error-messages="valueOperatorErrors" dense />
                        </v-col>

                        <v-col cols="12" class="modal-cadastro-form-col-imput mt-3" sm="3">
                          <!-- <v-btn :color="variables.colorSecondary" @click.prevent="clearOperator" class="mr-2" dark>Limpar</v-btn> -->
                          <v-btn :color="variables.colorSecondary" @click.prevent="addOperator()" dark>Add</v-btn>
                        </v-col>

                        <!-- Tabela lista operacoes -->
                        <v-col cols="12" class="pt-0 px-0 mt-2">
                          <v-card-text class="py-0 px-0">
                            <v-data-table :headers="headersOperators" :items="listOperatorContract"
                              :loading="loadingTableValues" height="auto" flat dense class="table-operator"
                              :items-per-page="10">

                              <template v-slot:body="{ items }">
                                <tbody>
                                  <tr v-for="(item, index) in items" :key="index">
                                    <td>{{ (getFields(item.fieldId)).text }}</td>
                                    <td> <span> {{ item.operator }} </span> </td>
                                    <td> {{ item.value | currency }} </td>
                                    <td>
                                      <!-- <v-icon small class="mr-2" @click="editValue(index)" > edit </v-icon> -->
                                      <v-icon small @click="deleteOperator(index)"> delete </v-icon>
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-data-table>
                          </v-card-text>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <!-- FIM CONDICAO -->

                  <!-- INIT PAGAMENTOS -->
                  <Pagamentos :item="item" />
                  <!-- FiM PAGAMENTOS -->
                </v-col>

              </v-row>
            </v-col>
            <v-col class="d-flex justify-center">
              <v-btn @click="showMoreProducts(true)" text color="#1E88E5" class="w-auto" dark
                v-if="item.contractTypeId === 'REC' && !showProducts">Mostrar lista
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
              <v-btn @click="showMoreProducts(false)" text color="#1E88E5" class="w-auto" dark
                v-if="item.contractTypeId === 'REC' && showProducts">Ocultar lista
                <v-icon>mdi-chevron-up</v-icon>
              </v-btn>
            </v-col>

            <!-- REC Formulario -->
            <div class="flex-column justify-space-between align-center">
              <template v-if="item.contractTypeId === 'REC'">
                <v-card class=" pt-0 px-0 modal-cadastro-form" v-for="(product, index) in filterProductsToShow"
                  :key="index">
                  <v-col cols="12" v-if="item.contractTypeId === 'REC'" class="pt-0">
                    <template v-if="filterNameProduct(product.productName)">
                      <v-card-text class="mb-4 mt-2 ml-8 v-card__title"> {{ filterNameProduct(product.productName) }}
                      </v-card-text>
                      <div class="title-divider">
                        <v-divider light class="other-divider"></v-divider>
                        <v-divider class="divider-icon"></v-divider>
                      </div>
                    </template>
                    <!-- Tipo contrato DEP NGR -->
                    <v-row>
                      <v-col cols="12" class="pt-0 pl-8 pb-0 mb-0">
                        <v-row>
                          <v-btn rounded color="primary" dark v-for=" (it, key) in defineTypeCommissionShow(product)"
                            :key="key" :outlined="!(it === product.comissionTypeId)"
                            @click="product.comissionTypeId = it" class="mx-4 mb-2 mt-2">
                            {{ it.text }}
                          </v-btn>
                        </v-row>
                      </v-col>
                      <v-col class="py-0">
                        <v-currency-field v-model="product.minRange" prefix="R$" label="Range Mínimo:"
                          @input="$v.product.minRange.$touch()" @blur="$v.product.minRange.$touch()"
                          :error-messages="minRangeErrors" disabled
                          class="text-body-2 px-4 ma-0" />
                      </v-col>
                      <v-col class="py-0">
                        <v-currency-field v-if="product.listRange.length > 0" v-model="product.maxRange" prefix="R$" label="Range Máximo:"
                          @input="$v.product.maxRange.$touch()" @blur="$v.product.maxRange.$touch()"
                          :error-messages="maxRangeErrorsNew(product)" class="text-body-2 px-4 ma-0"/>

                          <div v-else class="infinity-value" disabled>
                            {{ infinity }}
                          </div>
                      </v-col>
                      <v-col class="py-0">
                        <v-currency-field v-model="product.aliquot" prefix="%" label="Alíquota:"
                          @input="$v.product.aliquot.$touch()" @blur="$v.product.aliquot.$touch()" :max="100"
                          class="text-body-2 px-4 ma-0" />
                      </v-col>
                      <v-col class="py-0">
                        <v-btn rounded outlined @click.prevent="clearRange(product)">Limpar</v-btn>
                      </v-col>
                    </v-row>

                    <!-- TABELA REC CASSINO -->
                    <v-card-text class="px-0 py-0">
                      <v-data-table :headers="headers" :items="product.listRange" :loading="loadingTableValues" flat
                        dense :items-per-page="10" :hide-default-footer="true">
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr v-for="(item, index) in items" :key="index">
                              <!-- item.minRange | currency -->
                              <td>{{ item.minRange | currency}} </td>
                              <td>{{ setInfinityRangeMaxSimbol(product.listRange, item) }}</td>
                              <td>{{ item.aliquot || 0 }}%</td>
                              <td>
                                <v-icon small @click="deleteValueRange(product, index)"> delete </v-icon>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-col>
                  <div class="d-flex justify-center pb-2">
                    <v-btn rounded prepend-icon="mdi-plus" outlined :color="variables.colorSecondary"
                      @click.prevent="addRange(product)" dark>+ Adicionar</v-btn>
                  </div>
                </v-card>
              </template>
            </div>
          </v-row>

        </v-card-text>

        <v-card-actions class="modal-cadastro-footer">
          <v-btn tabindex="7" :color="variables.colorPrimary" @click="closeModal"
            class="br-btn br-btn-cancelar">Cancelar</v-btn>
          <v-btn tabindex="6" type="submit" :color="variables.colorPrimary" @click.prevent="cadastroContrato()"
            class="br-btn" :loading="loading">{{ isEdit ? 'Salvar' : 'Cadastrar' }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </Modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { currency } from '@/core/service/utils'
// eslint-disable-next-line
import { maxValue, minValue, required, requiredIf } from 'vuelidate/lib/validators'
import { mask } from 'vue-the-mask'
import Events from '@/core/service/events'
import variables from '@/assets/styles/helpers/_variables.scss'

// eslint-disable-next-line
import { map, filter, size, last, flatten, move, cloneDeep, orderBy } from 'lodash'
// eslint-disable-next-line
import { errorSnackbar, successSnackbar } from '@/core/service/utils'
import validacao from './validacao'
import autoCompleteTipoContratos from '../mixins/autoCompleteTipoContratos'
// eslint-disable-next-line
export default {
  name: 'ModalCadastroContratosAfiliado',
  mixins: [validationMixin, autoCompleteTipoContratos],
  directives: { mask },

  components: {
    Modal: () => import('@/views/components/modal'),
    Pagamentos: () => import('./pagamentos.vue')
  },

  data: () => ({
    loadingTableValues: false,
    show: false,
    activeModal: false,
    loading: false,
    showPassword: false,
    loadingBtnCadastro: false,
    loadingModal: false,
    tab: null,
    tabComission: null,
    editValues: false,
    typeComissionREC: {},
    showProducts: false,
    infinity: '∞',
    headers: [
      { align: 'start', class: 'table-header', text: 'Min. Range:', value: 'minRange', sortable: false },
      { align: 'start', class: 'table-header', text: 'Max. Range:', value: 'maxRange', sortable: false },
      { align: 'start', class: 'table-header', text: 'Alíquota:', value: 'aliquot', sortable: false },
      { align: 'end', class: 'table-header', text: '', value: 'action', sortable: false },
    ],
    headersOperators: [
      { align: 'start', class: 'table-header', text: 'Tipo:', value: 'type' },
      { align: 'start', class: 'table-header', text: 'Condição:', value: 'condition' },
      { align: 'start', class: 'table-header', text: 'Valor:', value: 'value' },
      { align: 'end', class: 'table-header', text: '', value: 'action', sortable: false },
    ],
  }),
  computed: {
    ...mapGetters('afiliadosContratos', ['item', 'itemCassino', 'itemProg', 'listaTypesContract', 'listTipeSelectContrato', 'listTipeSelectComission', 'itemValueRange', 'listLancamentoRangeValores', 'products']),
    ...mapGetters('afiliadosContratos', ['listaConditions', 'itemOperator', 'listTypeSelectOperators', 'listOperatorContract', 'listLancamentoRangeValoresCassino', 'listLancamentoRangeValoresProg']),
    ...mapGetters('afiliadosContratos', ['listPagamentos', 'listTipeSelectComissionFilter']),

    ...mapGetters('roles', ['permiteAcao']),
    ...validacao,
    variables: () => variables,
    isEdit() {
      return this.item.id ? !!1 : !!0
    },
    valorMinimoPermitido() {
      const lista = this.listLancamentoRangeValores
      const value = this.itemValueRange.minRange
      const minValues = map(lista, v => v.minRange).filter(v => value <= v)
      return { minValues, value, lista }
    },
    lastLancamento(it) {
      const dados = it.listRange
      return last(dados)
    },
    filterProductsToShow() {
      return this.products.filter(product => product.showProduct === true);
    }
  },
  mounted() {
    Events.$on('cadastro::openModalCadastro', () => {
      this.openModal()
      console.log(this.products);
      if (!this.isEdit) {
        this.getProducts()
      }
    })
  },
  methods: {
    ...mapActions('afiliadosContratos', ['cadastrarItem', 'editarItem', 'limparItem', 'getTypesContrato', 'getComissions', 'clearModal', 'getItens', 'getTypesCondicoes', 'getProducts']),

    /* range de valores */
    ...mapActions('afiliadosContratos', ['editValuesRange']),
    /* Operacoes */
    ...mapActions('afiliadosContratos', ['addTypeOperators', 'deleteTypeOperator', 'clearTypeOperator', 'clearPagamentos', 'incrementValueRange']),

    getFields(field) {
      if (typeof field === 'string') {
        const item = this.listaConditions.filter(v => v.value === field)[0]
        if (!item) return 'Tipo não encontrado'
        return item
      }
      return field
    },
    async addOperator() {
      if (this.$v.itemOperator.$invalid) {
        this.$v.itemOperator.$touch()
        return false
      }

      if (size(this.listOperatorContract) === 5) {
        return errorSnackbar('Error: Limite de cadastro de Condições atingido! ')
      }

      await this.addTypeOperators(this.itemOperator)
      this.clearTypeOperator()
      this.$v.itemOperator.$reset()
    },

    deleteOperator(idx) {
      this.deleteTypeOperator(idx)
      this.clearTypeOperator()
      this.$v.itemOperator.$reset()
    },

    maxRangeErrorsNew(it) {
      const errors = []
      if (!it.maxRange.$dirty) return errors
      !it.maxRange.required && errors.push('Campo Obrigatório!')
      !it.maxRange.minValue && errors.push('Valor muito baixo!')
      return errors
    },

    /* Values Ranges Geral */
    async addRange(it) {
      const payload = { maxRange: it.maxRange, minRange: it.minRange, aliquot: it.aliquot }

      // if (size(it.listRange) === 4) {
      //   return errorSnackbar('Error: Limite de Cadastro atingido! ')
      // }

      if (payload.maxRange <= 0 && it.listRange.length > 0) {
        return errorSnackbar('Error: Range Máximo menor ou igual a zero! ')
      }

      if (payload.maxRange < payload.minRange && it.listRange.length > 0) {
        // it.maxRange = payload.minRange + 1
        return errorSnackbar('Error: Range Máximo maior que o Range Mínimo! ')
      }

      this.addRangesValues(payload, it)
      this.incrementValue(it)
      this.clearRange(it)
      this.copyProprertiesDefault(it)
    },

    addRangesValues(payload, it) {
      if (payload.aliquot > 100) {
        it.aliquot = 0
        return errorSnackbar('Error: Alíquota maior que 100%! ')
      }
      it.listRange.push(Object.assign({}, payload))
      this.adjustValuesRangeList(it)

    },

    adjustValuesRangeList(it){
      if (it.listRange.length > 1){
        const lastIndex = it.listRange.length - 1
        const penultimateIndex = lastIndex - 1
        it.listRange[penultimateIndex].maxRange = it.maxRange
        it.listRange[lastIndex].minRange = it.maxRange + 0.01
      }
      last(it.listRange).maxRange = 9999999999
    },

    incrementValue(it) {
      it.minRange = it.maxRange + 0.01
      // it.maxRange += 1
    },

    clearOperator() {
      this.clearTypeOperator()
    },

    editValue(idx) {
      this.editValues = idx
      this.editValuesRange(idx)
    },

    getLastRangeValue(item) {
      if (item.length <= 0) return false
      const dados = item
      return last(dados)
    },

    deleteValueRange(item, index) {
      const filtro = item.listRange.filter((v, k) => k !== index)
      item.listRange = filtro
      this.readjustMinimumRange(item)
      last(item.listRange).maxRange = 9999999999
    },

    readjustMinimumRange(item) {
      if (item.listRange.length <= 1) {
        item.minRange = 0
      }
      const ultimo = this.getLastRangeValue(item.listRange)
      if (size(item.listRange) === 0) this.clearRange(item)
      if (!ultimo) return
      item.minRange = ultimo.minRange
    },

    clearRange(it) {
      it.maxRange = 0
      it.aliquot = 0
    },

    showMoreProducts(val) {
      this.products.filter(r => r.productName !== 'DEFAULT').map(p => p.showProduct = val)
      this.products.filter(r => r.productName === 'DEFAULT').map(p => p.showProduct = !val)
      this.showProducts = val
    },

    filterNameProduct(productFiltered) {
      if (productFiltered === 'DEFAULT') return false
      else return productFiltered
    },

    defineTypeCommissionShow(product) {
      const listSelectComissionTypes = product.productName !== 'DEFAULT' ? this.listTipeSelectComissionFilter(false, 'NGR') : this.listTipeSelectComissionFilter('REC')
      this.setDefaultComissionType(listSelectComissionTypes)
      this.setDefaultComissionTypeEdit(listSelectComissionTypes)
      return listSelectComissionTypes
    },

    setDefaultComissionType(listIsVisibleTypeComission) {
      const isVisibleProducts = this.products.filter(p => p.showProduct)
      if (listIsVisibleTypeComission.length === 1) {
        isVisibleProducts.map(p => p.comissionTypeId = listIsVisibleTypeComission[0])
      }
    },

    setDefaultComissionTypeEdit(listIsVisibleTypeComission) {
      const isVisibleProducts = this.products.filter(p => p.productName === 'DEFAULT')
      const setComissionType = listIsVisibleTypeComission.filter(l => l.id === isVisibleProducts[0].comissionTypeId)
      if (setComissionType.length > 0) isVisibleProducts.map(p => p.comissionTypeId = setComissionType[0])
    },

    showProductsIsEdit() {
      const nomesProdutosComListRange = this.products
        .filter(p => p.listRange.length > 0)
        .map(p => p.productName)
      if (nomesProdutosComListRange.length > 0 && nomesProdutosComListRange[0] !== 'DEFAULT') {
        this.showMoreProducts(true)
      }
    },

    copyProprertiesDefault(it) {
      if (it.productName === 'DEFAULT') {
        const filteredProducts = this.products.filter(p => p.productName !== 'DEFAULT')
        filteredProducts.forEach(p => p.listRange = cloneDeep(it.listRange))
      } else {
        // this.clearDefaultValues()
      }
    },

    getProductsSave() {
      const produtosComListRange = filter(this.products, (produto) => {
        return produto.showProduct && produto.listRange.length > 0
      })
      return produtosComListRange
    },

    setInfinityRangeMaxSimbol(products, item) {
      if (products.length >= 1) {
        if (item.maxRange >= 9999999999) {
          return '∞'
        } else {
          return currency(item.maxRange)
        }
      } else {
        return '∞'
      }
      // if (products.length > 0){
      //     const lastIndex = products.length - 1
      //     const currentIndex = products.findIndex(obj => obj === item)

      //     if (currentIndex === lastIndex) {
      //       return '∞'
      //     } else {
      //       return currency(item.maxRange)
      //     }
      // } else {
      //   '∞'
      // }
    },
    setInfinityRangeMinSimbol(products, item) {
      if (products.length > 0) {
        const lastIndex = products.length - 1
        const currentIndex = products.findIndex(obj => obj === item)

        if (currentIndex === lastIndex && currentIndex > 0) {
          return currency(products[currentIndex].maxRange)
        } else {
          return currency(item.minRange)
        }
      }
    },

    clearProductsValues() {
      this.products.forEach(product => {
        if (product.productName !== 'DEFAULT') {
          product.maxRange = 0
          product.minRange = 0
          product.aliquot = 0
          product.comissionTypeId = null
          product.listRange = []
        }
      })
    },

    clearDefaultValues() {
      this.products.forEach(product => {
        if (product.productName === 'DEFAULT') {
          product.maxRange = 0
          product.minRange = 0
          product.aliquot = 0
          product.comissionTypeId = null
          product.listRange = []
        }
      })
    },

    sortByMaxRange(a, b) {
      if (a.maxRange === '9999999999.00') return 1
      if (b.maxRange === '9999999999.00') return -1
      return a.maxRange - b.maxRange
    },

    async openModal() {
      if (!this.isEdit) {
        this.getProducts()
      }
      if (this.isEdit) {
        // Ordena o listRange
        this.products.forEach(product => {
          product.listRange.sort(this.sortByMaxRange)
        })
        this.showProductsIsEdit()
      }
      this.activeModal = true
      this.loadingModal = true
      this.loadingBtnCadastro = true
      Promise.all([
        this.getTypesContrato(),
      ]).then(() => {
        this.loadingModal = false
        this.loadingBtnCadastro = false
      }).finally(() => {
        this.loadingModal = false
        this.loadingBtnCadastro = false
      })
    },

    formatProductsTypeREC() {
      // const checkProductsRegister = this.products.filter(p => p.listRange.length !== 0)
      const checkProductsRegister = this.getProductsSave()
      return flatten(map(checkProductsRegister, it => {
        const rangesformat = map(it.listRange, ls => {
          if (!it.listValues) {
            return {
              comissionTypeId: it.comissionTypeId.id,
              minRange: ls.minRange,
              maxRange: ls.maxRange,
              aliquot: ls.aliquot,
              regionProductId: it.regionProductId
            }
          }
        })
        return rangesformat
      }))
    },

    isInvalidProductRegister() {
      const errors = []
      const invalidProducts = this.filterProductsToShow.filter(p => {
        if (p.listRange.length < 1) errors.push('Faixas de valores não preenchidas')
        if (p.comissionTypeId === null) errors.push('Tipo de comissão não selecionado')
        if (p.listRange.length < 1 || p.comissionTypeId === null) return true
      })

      if (this.filterProductsToShow.length > 1) {
        return { invalid: invalidProducts.length > 0 && invalidProducts.length === this.filterProductsToShow.length, errors: errors }
      } else {
        return { invalid: invalidProducts.length > 0, errors: errors }
      }
    },

    async cadastroContrato() {
      const vm = this

      if (this.$v.item.$invalid) {
        this.$v.item.$touch()
        return false
      }
      if (this.isInvalidProductRegister().invalid && this.item.contractTypeId === 'REC') {
        this.isInvalidProductRegister().errors.map(e => {
          errorSnackbar(e)
        })
        return false
      }

      this.loading = true

      // valores ranges
      this.item.listValues = map(this.listLancamentoRangeValores, v => {
        return {
          ...v,
          contractTypeId: vm.item.contractTypeId,
          comissionTypeId: vm.item.comissionTypeId,
        }
      })

      if (this.item.contractTypeId === 'REC') {
        this.item.listValues = this.formatProductsTypeREC()
        console.log(this.item.listValues)
      }
      // if (this.item.listValues) return false

      // condicoes
      if (this.listOperatorContract[0]) {
        this.item.listValueConditions = map(this.listOperatorContract, v => {
          return {
            ...v,
            contractTypeId: this.item.contractTypeId,
            contractId: vm.item.contractTypeId,
            comissionTypeId: vm.item.comissionTypeId,
            fieldId: v.fieldId.value
          }
        })
      }

      // Pagamentos
      if (this.listPagamentos[0]) {
        this.item.listValuePagamentos = map(this.listPagamentos, v => {
          return {
            ...v,
            contractTypeId: vm.item.contractTypeId
          }
        })
      }

      if (this.item.contractTypeId === 'CPA') {
        if (size(this.listPagamentos) === 0) {
          this.loading = false
          return errorSnackbar('Realize o cadastro de Pagamentos!')
        }
        if (size(this.listOperatorContract) === 0) {
          this.loading = false
          return errorSnackbar('Realize o cadastro das Condições!')
        }
      }
      const dados = Object.assign({}, this.item)
      this.cadastrarItem(dados).then(() => {
        successSnackbar('Cadastro realizado com sucesso!')
        Events.$emit('reload::table::index')
      }).catch(err => errorSnackbar(err.message))
        .finally(() => {
          this.loading = false
          this.closeModal()
        })
    },

    resetShowedProducts() {
      this.products.filter(p => p.productName !== 'DEFAULT').map(p => p.showProduct = false)
      this.products.filter(p => p.productName === 'DEFAULT').map(p => p.showProduct = true)
    },

    closeModal() {
      this.activeModal = false
      this.showProducts = false
      this.showMoreProducts(this.showProducts)
      this.limparItem()
      this.clearModal()
      this.clearPagamentos()
      this.$v.item.$reset()
      this.resetShowedProducts()
      this.getProducts()
    },
  },

  validations() {
    const self = this
    /* validacao valores ranges */
    // const valores = this.itemValueRange.minRange
    const valoresMax = this.itemValueRange.maxRange
    const isEdit = this.editValues
    /* validacao valores operacao */
    const opConditions = this.itemOperator.operator
    const opValue = this.itemOperator.value
    const opFieldId = this.itemOperator.fieldId

    return {
      product: {
        comissionTypeId: { required },
        maxRange: { required },
        minRange: { required },
        aliquot: { required, maxValue: maxValue(100), minValue: minValue(0) }
      },

      itemValueRange: {
        minRange: {
          required
        },
        maxRange: {
          required,
          minValue: minValue(0.01),
          minValueExist: () => {
            let minValues = map(self.listLancamentoRangeValores, v => v.maxRange).filter(v => valoresMax <= v)

            if (isEdit) {
              const dados = filter(self.listLancamentoRangeValores, (v, k) => k !== isEdit)
              minValues = map(dados, v => v.maxRange).filter(v => valoresMax <= v)
            }
            return size(minValues) ? !!0 : !!1
          }
        },
        aliquot: { required }
      },
      item: {
        name: { required },
        contractTypeId: { required },

      },
      itemOperator: {
        fieldId: { required,
          isValidField: () => {
            let minOperation = filter(self.listOperatorContract, v => v.fieldId.value === opFieldId.value)
            return size(minOperation) ? !!0 : !!1
          }
         },
        operator: {
          required,
          isValidOperation: () => {
            let minOperation = filter(self.listOperatorContract, v => v.operator === opConditions && v.fieldId.value === opFieldId.value)
            return size(minOperation) ? !!0 : !!1
          }
        },
        value: {
          required,
          minValue: minValue(0.01),
          isValidValue: () => {
            let minOperation = filter(self.listOperatorContract, v => v.condition === opConditions && v.value >= opValue)
            return size(minOperation) ? !!0 : !!1
          }
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../../../assets/styles/components/_formularios';
@import '../../../../assets/styles/components/_modal-cadastro';

// .modal-cadastro-form . {
//   border: 1px solid black;
//   padding: 5px;
//   border-radius: 10px;
// }
table tbody tr td span {
  background: cadetblue;
  width: 50px;
  border-radius: 10px;
  min-width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  font-size: 18px;

  &:hover {
    opacity: 0.8;
  }
}

.infinity-value {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid black;
  align-items: center;
  height: 45px;
}

.contrato {
  margin: 0 !important;
  padding: 0 !important;
}

.title-divider {
  position: relative;
  padding-bottom: 8px;
  bottom: 15px;

  .divider-icon {
    display: flex;
    width: 100% !important;
  }

  .other-divider {
    max-width: 10% !important;
    height: 3px !important;
    max-height: 3px !important;
    position: relative;
    background-color: #e3e614;
    width: 53px;
    left: 30px;
  }
}
</style>